import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';
import { useIsMediumDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsMediumDesktopAndAbove';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { glossary } from '@sorare/core/src/lib/glossary';

import { Blog } from '@sorare/gameplay/src/components/home/Blog';
import { CommonMarket } from '@sorare/gameplay/src/components/home/CommonMarket';
import { ScoutingCenterTile } from '@sorare/gameplay/src/components/scoutingCenter/ScoutingCenterTile';

import { CompetitionHistory } from './CompetitionHistory';
import { KeepScouting } from './KeepScouting';

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: var(--c-nd-100);
`;

const Layout = styled.div`
  display: grid;
  gap: var(--double-unit);
  justify-content: stretch;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;

  & > * {
    width: 100%;
    height: 170px;
  }
  /* stretch last element if alone on line */
  & :nth-child(2n + 1):last-child {
    grid-column: 1/3;
  }
`;

export const ForYou = () => {
  const isCompact = useIsMediumDesktopAndAbove();
  const {
    flags: { useMlbOffseason = false },
  } = useFeatureFlags();

  if (isCompact) {
    return (
      <Vertical gap={2}>
        <LabelL bold>
          <FormattedMessage {...glossary.forYou} />
        </LabelL>
        <Vertical gap={2}>
          {!useMlbOffseason ? (
            <>
              <CommonMarket compact />
              <Divider />
              <ScoutingCenterTile compact />
              <Divider />
            </>
          ) : (
            <>
              <KeepScouting compact />
              <Divider />
            </>
          )}
          <Blog compact />
          <Divider />
          <CompetitionHistory compact />
        </Vertical>
      </Vertical>
    );
  }

  return (
    <Vertical gap={2}>
      <LabelL bold>
        <FormattedMessage {...glossary.forYou} />
      </LabelL>
      <Layout>
        {useMlbOffseason ? (
          <KeepScouting />
        ) : (
          <>
            <CommonMarket />
            <ScoutingCenterTile />
          </>
        )}
        <Blog />
        <CompetitionHistory />
      </Layout>
    </Vertical>
  );
};
